import { createContext, useEffect, useState } from "react";
import { productsArray, getProductData } from "./components/productsData";

export const CartContext = createContext({
  items: [],
  getProductQuantity: () => {},
  addOneToCart: () => {},
  removeOneFromCart: () => {},
  deleteFromCart: () => {},
  getTotalCost: () => {},
  setCart: () => {},
  clearCart: () => {},
});

export function CartProvider({ children }) {
  const [cartProducts, setCartProducts] = useState([]);

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem("cart"));
    if (storedCart) {
      setCartProducts(storedCart);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cartProducts));
  }, [cartProducts]);

  function getProductQuantity(id) {
    return cartProducts.find((product) => product.id === id)?.quantity || 0;
  }

  function addOneToCart(id, finalPrice, quantity = 1) {
    const existingProduct = cartProducts.find((product) => product.id === id);
    if (existingProduct) {
      setCartProducts((prevCart) =>
        prevCart.map((product) =>
          product.id === id
            ? { ...product, quantity: product.quantity + quantity }
            : product
        )
      );
    } else {
      const productToAdd = getProductData(id);
      setCartProducts((prevCart) => [
        ...prevCart,
        { ...productToAdd, quantity, finalPrice },
      ]);
    }
  }

  function removeOneFromCart(id) {
    const quantity = getProductQuantity(id);
    if (quantity === 1) {
      deleteFromCart(id);
    } else {
      setCartProducts((prevCart) =>
        prevCart.map((product) =>
          product.id === id
            ? { ...product, quantity: product.quantity - 1 }
            : product
        )
      );
    }
  }

  function deleteFromCart(id) {
    setCartProducts((prevCart) =>
      prevCart.filter((currentProduct) => currentProduct.id !== id)
    );
  }

  function getTotalCost() {
    return cartProducts.reduce(
      (total, cartItem) => total + cartItem.finalPrice * cartItem.quantity,
      0
    );
  }

  const setCart = (newCart) => {
    setCartProducts(newCart);
  };

  const clearCart = () => {
    setCartProducts([]);
    localStorage.removeItem("cart");
  };

  const contextValue = {
    items: cartProducts,
    getProductQuantity,
    addOneToCart,
    removeOneFromCart,
    deleteFromCart,
    getTotalCost,
    setCart,
    clearCart,
  };

  return (
    <CartContext.Provider value={contextValue}>{children}</CartContext.Provider>
  );
}

export default CartProvider;
